import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { appRoutes } from './features/shell/app.routes';
import { environment } from '../environments/environment';
import { provideCoreAuth } from '@net3-multiplatform-client/libs';
import { provideIonicAngular } from '@ionic/angular/standalone';
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withViewTransitions()),
    provideCoreAuth(environment),
    provideIonicAngular({
      useSetInputAPI: true
    }),
    { provide: LOCALE_ID, useValue: 'es' }
  ],
};
